<template>
  <div>
    <PCNavbar />
    <MobileNavBar />
    <SynologyForm />
<!--    <CallMe/>-->
<!--    <MobileCallme/>-->
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import SynologyForm from '@/components/synology/index-new.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    SynologyForm,
  },
}
</script>

<style>
</style>